import { useTypedTranslations } from '~/components/translation/use-translations';
import { SportsbookShowMoreToggle } from '../../../components/show-more';
import useSportsbookRoutes from '../../../hooks/use-sportsbook-routes';
import useQuerySports from '../../../queries/sports/use-query-sports';
import { MenuHeader, MenuHeaderLabel, MenuList, MenuListItem, MenuWrapper } from './sportsbook-desktop-menu-layout';
import DesktopMenuTextKeys from '../sportsbook-desktop-menu-text-keys';
import { RefetchInterval, StaleTime } from '../../../sportsbook-constants';
import localeCompare from '~/utils/localeCompare';
import { useState } from 'react';
import SportsbookTextKeys from '../../../sportsbook-text-keys';

const SPORTS_LIMIT = 15;

type Props = {
	className?: string;
};

const SportsbookDesktopMenuSports: React.FC<Props> = ({ className }) => {
	const [isExpanded, setExpanded] = useState(false);
	const {
		data: sports,
		isPending,
		isError
	} = useQuerySports({
		refetchInterval: RefetchInterval.LONG,
		staleTime: StaleTime.LONG,
		select: data => [...data].sort((a, b) => localeCompare(a.name, b.name))
	});
	const { getSportPageLink } = useSportsbookRoutes();
	const { translate } = useTypedTranslations(DesktopMenuTextKeys);
	const { translations: sportsbookTranslations, isLoadingTranslations: isLoadingSportsbookTranslations } =
		useTypedTranslations(SportsbookTextKeys);

	if (isError) {
		return null;
	}

	if (isPending) {
		return null;
	}

	const visibleSports = isExpanded ? sports : sports.slice(0, SPORTS_LIMIT);

	return (
		<MenuWrapper className={className}>
			<MenuHeader>
				<MenuHeaderLabel>{translate(DesktopMenuTextKeys.ALL_SPORTS_LABEL)}</MenuHeaderLabel>
			</MenuHeader>
			<MenuList>
				{visibleSports.map(sport => (
					<MenuListItem
						key={sport.id}
						to={getSportPageLink(sport.id, sport.name)}
						title={sport.name}
						sportIcon={sport.icon}
					/>
				))}
			</MenuList>
			{sports.length > SPORTS_LIMIT && !isLoadingSportsbookTranslations && (
				<SportsbookShowMoreToggle
					isExpanded={isExpanded}
					translations={sportsbookTranslations}
					onClick={() => setExpanded(prev => !prev)}
				/>
			)}
		</MenuWrapper>
	);
};

export default SportsbookDesktopMenuSports;
